import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";

const PromotionEditorPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <SectionWrapper>
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-4">Editor de Promociones</h2>
          <p>Configura descuentos, fechas, reglas y productos asociados.</p>
        </div>
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PromotionEditorPage;
